export var YEARS_IN_ROW = 4;
export var YEAR_PICKER_DEFAULT_PROPS = {
  minYear: 1900,
  maxYear: new Date().getFullYear()
};